import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ClientService {
    id: number;
    name: string;
    type_id: number;
    amount: number;
    created_at: string;
    is_paid: boolean;
    assigned_id: number;
    isTransferred?: boolean;
    [key: string]: any;
}

interface ClientServicesState {
    assigned: ClientService[];
    loading: boolean;
    error: string | null;
}

const initialState: ClientServicesState = {
    assigned: [],
    loading: false,
    error: null,
};

export const clientServicesSlice = createSlice({
    name: 'clientServices',
    initialState,
    reducers: {
        setAssignedServices: (state, action: PayloadAction<ClientService[]>) => {
            state.assigned = action.payload;
        },
        setAssignedServicesLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const { setAssignedServices, setAssignedServicesLoading } = clientServicesSlice.actions;

export const selectAssignedServices = (state: any) => state.clientServices?.assigned || [];
export const selectAssignedServiceById = (id: number) => (state: any) =>
    state.clientServices?.assigned?.find((s: ClientService) => s.id === id);

export default clientServicesSlice.reducer;